<template>
   <div class="sidebar-wrapper" data-simplebar="true">
      <div class="sidebar-header">
         <div
            class="sidebar-brand"
            role="button"
            tabindex="0"
            title="Ir para Página Inicial"
            @click="irParaPaginaInicial"
            @keydown.enter.prevent="irParaPaginaInicial"
            @keydown.space.prevent="irParaPaginaInicial"
         >
            <div class="logo-icon logo-icon-theme" role="img" aria-label="Logotipo Escalador"></div>
            <h4 class="logo-text"><span class="d-block">Escalador</span><small class="d-block font-10 weight-500 color-theme">ERP</small></h4>
         </div>
         <div class="toggle-icon ms-auto" @click="alternarSidebar"><i class='bx bx-arrow-to-left'></i></div>
      </div>
      
      <ul class="metismenu" id="menu">
         <li class="menu-label" v-if="temPermissaoGrupoMenu(['pagina-inicial', 'conversas'])">Geral</li>
         <li v-if="temPermissaoSecao('pagina-inicial')" :class="{ 'mm-active': secaoMenuAtiva('pagina-inicial'), 'menu-route-active': secaoMenuAtiva('pagina-inicial') }" data-secao="pagina-inicial">
            <a href="javascript:;" @click="selecionarSecao('pagina-inicial')">
               <div class="parent-icon"><i class='far fa-home'></i></div>
               <div class="menu-title">Página Inicial</div>
            </a>
         </li>
         <li v-if="temPermissaoSecao('conversas')" :class="{ 'mm-active': secaoMenuAtiva('conversas'), 'menu-route-active': secaoMenuAtiva('conversas') }" data-secao="conversas">
            <a href="javascript:;" @click="selecionarSecao('conversas')">
               <div class="parent-icon"><i class='far fa-comments'></i></div>
               <div class="menu-title">Conversas <span v-if="totalUnreadChatMessages > 0" class="badge rounded-pill bg-danger ms-2">{{ totalUnreadChatMessages }}</span></div>
            </a>
         </li>
         <li class="menu-label" v-if="temPermissaoGrupoMenu(['usuarios', 'empresas', 'pessoas', 'produtos', 'frotas', 'servicos', 'pdv-cadastros', 'financeiro-cadastros'])">Cadastros</li>
         <li v-if="temPermissaoSecao('pessoas')" :class="{ 'mm-active': secaoMenuAtiva('pessoas'), 'menu-route-active': secaoMenuAtiva('pessoas') }" data-secao="pessoas">
            <a href="javascript:;" @click="selecionarSecao('pessoas')">
               <div class="parent-icon"><i class='far fa-id-card'></i></div>
               <div class="menu-title">Pessoas</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li v-if="temPermissaoSecao('produtos')" :class="{ 'mm-active': secaoMenuAtiva('produtos'), 'menu-route-active': secaoMenuAtiva('produtos') }" data-secao="produtos">
            <a href="javascript:;" @click="selecionarSecao('produtos')">
               <div class="parent-icon"><i class='far fa-box'></i></div>
               <div class="menu-title">Produtos</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li v-if="temPermissaoSecao('frotas')" :class="{ 'mm-active': secaoMenuAtiva('frotas'), 'menu-route-active': secaoMenuAtiva('frotas') }" data-secao="frotas"><a href="javascript:;" @click="selecionarSecao('frotas')"><div class="parent-icon"><i class="far fa-truck"></i></div><div class="menu-title">Frotas</div><div class="accordion-button"></div></a></li>
         <li v-if="temPermissaoSecao('servicos')" :class="{ 'mm-active': secaoMenuAtiva('servicos'), 'menu-route-active': secaoMenuAtiva('servicos') }" data-secao="servicos">
            <a href="javascript:;" @click="selecionarSecao('servicos')">
               <div class="parent-icon"><i class='far fa-wrench'></i></div>
               <div class="menu-title">Serviços</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li v-if="temPermissaoSecao('pdv-cadastros')" :class="{ 'mm-active': secaoMenuAtiva('pdv-cadastros'), 'menu-route-active': secaoMenuAtiva('pdv-cadastros') }" data-secao="pdv-cadastros">
            <a href="javascript:;" @click="selecionarSecao('pdv-cadastros')">
               <div class="parent-icon"><i class='far fa-cash-register'></i></div>
               <div class="menu-title">Comercial</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li v-if="temPermissaoSecao('financeiro-cadastros')" :class="{ 'mm-active': secaoMenuAtiva('financeiro-cadastros'), 'menu-route-active': secaoMenuAtiva('financeiro-cadastros') }" data-secao="financeiro-cadastros">
            <a href="javascript:;" @click="selecionarSecao('financeiro-cadastros')">
               <div class="parent-icon"><i class='far fa-folder-plus'></i></div>
               <div class="menu-title">Financeiro</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li v-if="temPermissaoSecao('usuarios')" :class="{ 'mm-active': secaoMenuAtiva('usuarios'), 'menu-route-active': secaoMenuAtiva('usuarios') }" data-secao="usuarios">
            <a href="javascript:;" @click="selecionarSecao('usuarios')">
               <div class="parent-icon"><i class='far fa-user'></i></div>
               <div class="menu-title">Usuários</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li v-if="temPermissaoSecao('empresas')" :class="{ 'mm-active': secaoMenuAtiva('empresas'), 'menu-route-active': secaoMenuAtiva('empresas') }" data-secao="empresas">
            <a href="javascript:;" @click="selecionarSecao('empresas')">
               <div class="parent-icon"><i class='far fa-building'></i></div>
               <div class="menu-title">Empresas</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <!-- <li v-if="temPermissaoSecao('vendas')" :class="{ 'mm-active': secoes['vendas'].tabs.some(tab => tab.path == $route.path) }" data-secao="vendas">
            <a href="javascript:;" @click="selecionarSecao('vendas')">
               <div class="parent-icon"><i class='far fa-cash-register'></i></div>
               <div class="menu-title">Vendas</div>
               <div class="accordion-button"></div>
            </a>
         </li> -->
         <li class="menu-label" v-if="temPermissaoGrupoMenu(['comercial', 'estoque', 'pdv', 'pdv-offline', 'financeiro-operacional', 'convenios'])">Operações</li>
         <li v-if="temPermissaoSecao('comercial')" :class="{ 'mm-active': secaoMenuAtiva('comercial'), 'menu-route-active': secaoMenuAtiva('comercial') }" data-secao="comercial">
            <a href="javascript:;" @click="selecionarSecao('comercial')">
               <div class="parent-icon"><i class='far fa-file-invoice'></i></div>
               <div class="menu-title">Comercial</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li v-if="temPermissaoSecao('estoque')" :class="{ 'mm-active': secaoMenuAtiva('estoque'), 'menu-route-active': secaoMenuAtiva('estoque') }" data-secao="estoque">
            <a href="javascript:;" @click="selecionarSecao('estoque')">
               <div class="parent-icon"><i class='far fa-boxes'></i></div>
               <div class="menu-title">Estoque</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li v-if="temPermissaoSecao('estoque')" :class="{ 'mm-active': $route.path === '/estoque/pendencias' }" data-secao="estoque">
            <router-link to="/estoque/pendencias">
               <div class="parent-icon"><i class='bx bx-error-circle'></i></div>
               <div class="menu-title">Pendências Estoque</div>
            </router-link>
         </li>
         <li v-if="temPermissaoSecao('pdv')" :class="{ 'mm-active': secaoMenuAtiva('pdv'), 'menu-route-active': secaoMenuAtiva('pdv') }" data-secao="pdv">
            <a href="javascript:;" @click="selecionarSecao('pdv')">
               <div class="parent-icon"><i class='far fa-store'></i></div>
               <div class="menu-title">PDV</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li v-if="temPermissaoSecao('pdv-offline')" :class="{ 'mm-active': secaoMenuAtiva('pdv-offline'), 'menu-route-active': secaoMenuAtiva('pdv-offline') }" data-secao="pdv-offline">
            <a href="javascript:;" @click="selecionarSecao('pdv-offline')">
               <div class="parent-icon"><i class='bx bx-devices'></i></div>
               <div class="menu-title">PDV Offline</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li v-if="temPermissaoSecao('financeiro-operacional')" :class="{ 'mm-active': secaoMenuAtiva('financeiro-operacional'), 'menu-route-active': secaoMenuAtiva('financeiro-operacional') }" data-secao="financeiro-operacional">
            <a href="javascript:;" @click="selecionarSecao('financeiro-operacional')">
               <div class="parent-icon"><i class='far fa-hard-hat'></i></div>
               <div class="menu-title">Financeiro</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li v-if="temPermissaoSecao('convenios')" :class="{ 'mm-active': secaoMenuAtiva('convenios'), 'menu-route-active': secaoMenuAtiva('convenios') }" data-secao="convenios">
            <a href="javascript:;" @click="selecionarSecao('convenios')">
               <div class="parent-icon"><i class='bx bx-wallet'></i></div>
               <div class="menu-title">Convênios</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li class="menu-label" v-if="temPermissaoGrupoMenu(['fiscal', 'arquivos-contabeis'])">Mov. Fiscais</li>
         <li v-if="temPermissaoSecao('fiscal')" :class="{ 'mm-active': secaoMenuAtiva('fiscal'), 'menu-route-active': secaoMenuAtiva('fiscal') }" data-secao="fiscal">
            <a href="javascript:;" @click="selecionarSecao('fiscal')">
               <div class="parent-icon"><i class='far fa-file-invoice'></i></div>
               <div class="menu-title">Mov. Fiscais</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li v-if="temPermissaoSecao('arquivos-contabeis')" :class="{ 'mm-active': secaoMenuAtiva('arquivos-contabeis'), 'menu-route-active': secaoMenuAtiva('arquivos-contabeis') }" data-secao="arquivos-contabeis">
            <a href="javascript:;" @click="selecionarSecao('arquivos-contabeis')">
               <div class="parent-icon"><i class='far fa-file-export'></i></div>
               <div class="menu-title">Arquivos Contábeis</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li class="menu-label" v-if="temPermissaoGrupoMenu(['relatorios'])">Análises</li>
         <li v-if="temPermissaoSecao('relatorios')" :class="{ 'mm-active': secaoMenuAtiva('relatorios'), 'menu-route-active': secaoMenuAtiva('relatorios') }" data-secao="relatorios">
            <a href="javascript:;" @click="selecionarSecao('relatorios')">
               <div class="parent-icon"><i class='far fa-chart-line'></i></div>
               <div class="menu-title">Relatórios</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li class="menu-label" v-if="temPermissaoGrupoMenu(['financeiro-configuracoes', 'changelog', 'assinatura', 'support'])">Sistema</li>
         <li v-if="temPermissaoSecao('financeiro-configuracoes')" :class="{ 'mm-active': secaoMenuAtiva('financeiro-configuracoes'), 'menu-route-active': secaoMenuAtiva('financeiro-configuracoes') }" data-secao="financeiro-configuracoes">
            <a href="javascript:;" @click="selecionarSecao('financeiro-configuracoes')">
               <div class="parent-icon"><i class='far fa-cog'></i></div>
               <div class="menu-title">Configurações</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li v-if="temPermissaoSecao('changelog')" :class="{ 'mm-active': secaoMenuAtiva('changelog'), 'menu-route-active': secaoMenuAtiva('changelog') }" data-secao="changelog">
            <a href="javascript:;" @click="selecionarSecao('changelog')">
               <div class="parent-icon"><i class='bx bx-history'></i></div>
               <div class="menu-title">Notas de Versão</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li v-if="temPermissaoSecao('assinatura')" :class="{ 'mm-active': secaoMenuAtiva('assinatura'), 'menu-route-active': secaoMenuAtiva('assinatura') }" data-secao="assinatura">
            <a href="javascript:;" @click="selecionarSecao('assinatura')">
               <div class="parent-icon"><i class='bx bx-badge-check'></i></div>
               <div class="menu-title">Minha Assinatura</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li v-if="temPermissaoSecao('support')" :class="{ 'mm-active': secaoMenuAtiva('support'), 'menu-route-active': secaoMenuAtiva('support') }" data-secao="support">
            <a href="javascript:;" @click="selecionarSecao('support')">
               <div class="parent-icon"><i class='bx bx-support'></i></div>
               <div class="menu-title">Suporte / Report</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <!-- <li :class="{ 'mm-active': isFinanceiroPaiAtivo }" data-secao="financeiro">
            <a href="javascript:;">
               <div class="parent-icon"><i class='far fa-dollar-sign'></i></div>
               <div class="menu-title">Financeiro</div>
               <div class="accordion-button"></div>
            </a>
            <ul class="financeiro-submenu">
               <li :class="{ 'sub-ativo': isFinanceiroCadastrosAtivo }">
                  <a href="javascript:;" class="submenu-link" @click="selecionarFinanceiroCadastros">Cadastros</a>
               </li>
               <li :class="{ 'sub-ativo': isFinanceiroOperacionalAtivo }">
                  <a href="javascript:;" class="submenu-link" @click="selecionarSecao('financeiro-operacional')">Operacional</a>
               </li>
               <li :class="{ 'sub-ativo': isFinanceiroConfiguracoesAtivo }">
                  <a href="javascript:;" class="submenu-link" @click="selecionarSecao('financeiro-configuracoes')">Configurações</a>
               </li>
            </ul>
         </li> -->
      </ul>
   </div>
</template>

<script>

import Vue from 'vue'
import $ from 'jquery'
import { mapState } from 'vuex'

export default {
	name: 'MenuLateral',
   computed: {
      ... mapState({
         secaoAtiva: state => state.secaoAtiva,
         secoes: state => state.secoes,
         totalUnreadChatMessages: state => state.totalUnreadChatMessages,
         isLogado: state => state.isLogado
      }),
      // isFinanceiroCadastrosAtivo() {
      //    const tabs = this.secoes['financeiro-cadastros'] ? this.secoes['financeiro-cadastros'].tabs : [];
      //    return tabs.some(tab => tab.path === this.$route.path);
      // },
      // isFinanceiroConfiguracoesAtivo() {
      //    const tabs = this.secoes['financeiro-configuracoes'] ? this.secoes['financeiro-configuracoes'].tabs : [];
      //    return tabs.some(tab => tab.path === this.$route.path);
      // },
      // isFinanceiroOperacionalAtivo() {
      //    const tabs = this.secoes['financeiro-operacional'] ? this.secoes['financeiro-operacional'].tabs : [];
      //    return tabs.some(tab => tab.path === this.$route.path);
      // },
      // isFinanceiroPaiAtivo() {
      //    return this.isFinanceiroCadastrosAtivo || this.isFinanceiroConfiguracoesAtivo || this.isFinanceiroOperacionalAtivo
      //       || this.secaoAtiva === 'financeiro-cadastros' || this.secaoAtiva === 'financeiro-configuracoes' || this.secaoAtiva === 'financeiro-operacional';
      // }
   },
   watch: {
      // Monitora mudanças na rota para atualizar a seção ativa
      $route(to) {
         this.atualizarSecaoAtiva(to.path);
         // Força atualização das classes após mudança de rota
         this.$nextTick(() => {
            this.aplicarClassesAtivas();
         });
      },
      isLogado(novoValor) {
         if (novoValor) {
            this.iniciarPollingChat();
         } else {
            this.pararPollingChat();
         }
      }
   },
   methods: {
      irParaPaginaInicial() {
         if (this.$route.path !== '/paginaInicial') {
            this.$router.push('/paginaInicial').catch(() => {});
         } else if (this.secaoAtiva !== 'pagina-inicial') {
            this.$store.dispatch('setSecaoAtiva', 'pagina-inicial');
         }
      },
      selecionarSecao(secao) {
         if (this.selecionarSecaoMenu(secao)) return;
         if (secao != this.secaoAtiva) {
            this.$store.dispatch('setSecaoAtiva', secao);
            // Navegar para a primeira tab da seção a qual o usuário tem permissão
            const primeiraTab = this.$store.state.secoes[secao].tabs.find(t => this.temPermissaoRota(t.path));
            if (primeiraTab) {
               this.$router.push(primeiraTab.path).catch(() => {});
            }
         }
      },
      selecionarSecaoMenu(secao) {
         const secaoStore = this.$store.state.secoes[secao];
         if (!secaoStore || !Array.isArray(secaoStore.tabs)) return false;

         const primeiraTab = secaoStore.tabs.find(t => this.temPermissaoRota(t.path));
         if (primeiraTab && this.normalizarPath(this.$route.path) !== this.normalizarPath(primeiraTab.path)) {
            this.$router.push(primeiraTab.path).catch(() => {});
         } else if (secao !== this.secaoAtiva) {
            this.$store.dispatch('setSecaoAtiva', secao);
         }

         this.$nextTick(() => this.aplicarClassesAtivas());
         return true;
      },
      normalizarPath(path) {
         const valor = String(path || '').split('?')[0].replace(/\/+$/, '');
         return (valor || '/').toLowerCase();
      },
      rotaCombina(pathTab, pathAtual) {
         const tab = this.normalizarPath(pathTab);
         const atual = this.normalizarPath(pathAtual);
         return atual === tab || (tab !== '/' && atual.startsWith(`${tab}/`));
      },
      encontrarSecaoPorPath(path) {
         if (!path || !this.secoes) return null;
         return Object.keys(this.secoes).find(secao => {
            const tabs = this.secoes[secao] ? this.secoes[secao].tabs : [];
            return Array.isArray(tabs) && tabs.some(tab => this.rotaCombina(tab.path, path));
         }) || null;
      },
      secaoMenuAtiva(secao) {
         const secaoDaRota = this.encontrarSecaoPorPath(this.$route.path);
         return secaoDaRota ? secaoDaRota === secao : this.secaoAtiva === secao;
      },
      temPermissaoRota(path) {
         const route = this.$router.options.routes.find(r => r.path === path || r.redirect === path);
         if (!route || !route.meta || !route.meta.role) return true;
         
         const user = this.$store.state.dadosUsuario;
         if (!user) return false;
         
         const roles = user.roles || [];
         const modules = user.modules || [];
         
         const empresa = this.$store.state.empresa;
         const planRoles = (empresa && Array.isArray(empresa.planRoles) && empresa.planRoles.length > 0)
            ? empresa.planRoles
            : null;

         const requiredRoles = [].concat(route.meta.role);
         if (planRoles && !requiredRoles.some(role => planRoles.includes(role))) {
            return false;
         }

         return requiredRoles.some(role => roles.includes(role)) || modules.includes('COMPANY_ADMIN');
      },
      temPermissaoSecao(secaoKey) {
         if (secaoKey === 'pagina-inicial' || secaoKey === 'conversas') return true;
         const secao = this.secoes[secaoKey];
         if (!secao || !secao.tabs) return false;
         return secao.tabs.some(tab => this.temPermissaoRota(tab.path));
      },
      temPermissaoGrupoMenu(secoesArray) {
         return secoesArray.some(s => this.temPermissaoSecao(s));
      },
      // selecionarFinanceiroCadastros() {
      //    const secao = 'financeiro-cadastros';
      //    const primeiraTab = this.$store.state.secoes[secao].tabs[0];

      //    if (this.secaoAtiva !== secao) {
      //       this.$store.dispatch('setSecaoAtiva', secao);
      //    }

      //    if (primeiraTab && this.$route.path !== primeiraTab.path) {
      //       this.$router.push(primeiraTab.path);
      //    }
      // },
      atualizarSecaoAtiva(path) {
         const secaoEncontrada = this.encontrarSecaoPorPath(path);
         if (secaoEncontrada && this.secaoAtiva !== secaoEncontrada) {
            this.$store.dispatch('setSecaoAtiva', secaoEncontrada);
            return;
         }
         // Verificar qual seção corresponde ao path atual
         Object.keys(this.secoes).forEach(secao => {
            const tabs = this.secoes[secao].tabs;
            if (tabs.some(tab => tab.path === path)) {
               if (this.secaoAtiva !== secao) {
                  this.$store.dispatch('setSecaoAtiva', secao);
               }
            }
         });
      },
      aplicarClassesAtivas() {
         // Remove todas as classes mm-active e mm-show
         $(".metismenu li[data-secao]").removeClass("mm-active mm-show");

         const secaoAtiva = this.encontrarSecaoPorPath(this.$route.path) || this.secaoAtiva;
         if (secaoAtiva) {
            $(`.metismenu li[data-secao="${secaoAtiva}"]`).addClass("mm-active mm-show");
            this.aplicarEstadoSidebar(this.sidebarMinimizadaSalva(), false);
            return;
         }
         
         // Aplica classes baseado na rota atual
         const pathAtual = this.$route.path;
         
         // Verifica cada seção
         Object.keys(this.secoes).forEach(secao => {
            const tabs = this.secoes[secao].tabs;
            if (tabs.some(tab => tab.path === pathAtual)) {
               // Subseções do financeiro mantêm o agrupador financeiro aberto/ativo
               const secaoMenu = /*(secao === 'financeiro-cadastros' || secao === 'financeiro-operacional' || secao === 'financeiro-configuracoes') ? 'financeiro' :*/ secao;
               $(`.metismenu li[data-secao="${secaoMenu}"]`).addClass("mm-active mm-show");
            }
         });
         this.aplicarEstadoSidebar(this.sidebarMinimizadaSalva(), false);
      },
      sidebarMinimizadaSalva() {
         return localStorage.getItem('jair_sidebar_collapsed') === '1';
      },
      alternarSidebar() {
         this.aplicarEstadoSidebar(!$(".wrapper").hasClass("toggled"), true);
      },
      aplicarEstadoSidebar(minimizada, persistir = true) {
         const $wrapper = $(".wrapper");
         const $sidebar = $(".sidebar-wrapper");
         if (persistir) {
            localStorage.setItem('jair_sidebar_collapsed', minimizada ? '1' : '0');
         }
         $sidebar.off("mouseenter.sidebar-state mouseleave.sidebar-state");
         if (minimizada) {
            $wrapper.addClass("toggled");
            $sidebar.on("mouseenter.sidebar-state", function () {
               $wrapper.addClass("sidebar-hovered");
            });
            $sidebar.on("mouseleave.sidebar-state", function () {
               $wrapper.removeClass("sidebar-hovered");
            });
         } else {
            $wrapper.removeClass("toggled sidebar-hovered");
         }
      },
      iniciarPollingChat() {
         this.$store.dispatch('updateUnreadChatMessages');
         this.chatPollingInterval = setInterval(() => {
            this.$store.dispatch('updateUnreadChatMessages');
         }, 30000); // Atualiza a cada 30 segundos
      },
      pararPollingChat() {
         if (this.chatPollingInterval) {
            clearInterval(this.chatPollingInterval);
         }
      }
   },
   mounted() {
      Vue.nextTick(function () {
			$(function() {
            // Inicializa o metisMenu
            $("#menu").metisMenu()
         })

         // Aplica as classes iniciais baseado na rota atual
         this.atualizarSecaoAtiva(this.$route.path);
         this.aplicarClassesAtivas();
         this.aplicarEstadoSidebar(this.sidebarMinimizadaSalva(), false);

         // Previne que o metisMenu remova classes quando clicar fora
         $(document).off('click.menu-lateral').on('click.menu-lateral', function(e) {
            // Se não clicou no menu, reaplica as classes
            if (!$(e.target).closest('.metismenu').length) {
               this.aplicarClassesAtivas();
            }
         }.bind(this));

         if (this.isLogado) {
            this.iniciarPollingChat();
         }
		}.bind(this));
   },
   beforeDestroy() {
      // Remove o listener de cliques ao destruir o componente
      $(document).off('click.menu-lateral');
      this.pararPollingChat();
   }
}

</script>

<style scoped>
.logo-icon-theme {
   flex: 0 0 44px;
   height: 44px;
   background-image: var(--home-logo);
   background-color: #ffffff;
   background-repeat: no-repeat;
   background-position: center;
   background-size: calc(100% - 4px);
   border: 1px solid rgba(15, 23, 42, .08);
   border-radius: 9px;
}

.sidebar-brand {
   align-items: center;
   cursor: pointer;
   display: flex;
   min-width: 0;
   outline: none;
}

.sidebar-brand:focus-visible {
   border-radius: 8px;
   box-shadow: 0 0 0 .18rem color-mix(in srgb, var(--color-theme) 22%, transparent);
}

.sidebar-wrapper .metismenu > .menu-label {
   align-items: center;
   color: color-mix(in srgb, var(--color-theme) 78%, #334155);
   display: block;
   gap: 0;
   font-size: 10px;
   font-weight: 700;
   letter-spacing: .5px;
   line-height: 1;
   margin-top: 8px;
   padding: 12px 10px 4px;
   text-align: left;
   width: 100%;
}

.sidebar-wrapper .metismenu > .menu-label::after {
   display: none;
}

.sidebar-wrapper .metismenu > .menu-label:first-child {
   margin-top: 4px;
}

.sidebar-wrapper .metismenu a {
   border-radius: 8px;
   margin: 1px 6px;
   min-height: 34px;
   overflow: hidden;
}

.sidebar-wrapper .metismenu a .menu-title {
   flex: 1 1 auto;
   line-height: 1.25;
   min-width: 0;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}

.sidebar-wrapper .metismenu a .parent-icon {
   flex: 0 0 24px;
   text-align: center;
}

.sidebar-wrapper .metismenu a .accordion-button {
   display: none !important;
}

.sidebar-wrapper .metismenu .mm-active > a,
.sidebar-wrapper .metismenu .menu-route-active > a {
   background: var(--sidebar-active-bg);
   border-color: var(--sidebar-active-border);
   box-shadow: var(--sidebar-active-shadow);
   color: var(--sidebar-active-text);
   font-weight: 700;
}

.sidebar-wrapper .metismenu .mm-active > a .parent-icon,
.sidebar-wrapper .metismenu .menu-route-active > a .parent-icon {
   background: var(--sidebar-active-icon-bg);
   color: var(--sidebar-active-icon-text);
   box-shadow: var(--sidebar-active-icon-shadow);
}

@media screen and (min-width: 1025px) {
   .wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu a {
      justify-content: center;
      height: 38px;
      margin: 3px auto;
      min-height: 38px;
      padding-left: 0;
      padding-right: 0;
      width: 42px;
   }

   .wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .mm-active > a,
   .wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .menu-route-active > a {
      box-shadow: none;
      border-color: var(--sidebar-active-border);
   }

   .wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .mm-active > a .parent-icon,
   .wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .menu-route-active > a .parent-icon {
      background: var(--sidebar-active-icon-bg);
      color: var(--sidebar-active-icon-text);
   }

   .wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu a .parent-icon {
      flex-basis: auto;
      margin: 0;
   }

   .wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu a .accordion-button,
   .wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu a .menu-title,
   .wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu > .menu-label {
      display: none !important;
   }
}

/* .financeiro-submenu {
   border: 0 !important;
   background: transparent !important;
   padding: 4px 0 6px 18px !important;
   position: relative;
}

.financeiro-submenu li {
   position: relative;
}

.financeiro-submenu li + li {
   margin-top: 2px !important;
}

.financeiro-submenu li::before {
   content: "";
   position: absolute;
   left: 11px;
   top: 50%;
   width: 12px;
   border-top: 2px dotted rgba(95, 95, 95, 0.85);
   transform: translateY(-50%);
}

.financeiro-submenu li::after {
   content: "";
   position: absolute;
   left: 11px;
   top: -8px;
   bottom: -8px;
   border-left: 2px dotted rgba(95, 95, 95, 0.85);
}

.financeiro-submenu li:first-child::after {
   top: 50%;
}

.financeiro-submenu li:last-child::after {
   bottom: 50%;
}

.sidebar-wrapper .metismenu .financeiro-submenu .submenu-link {
   border-radius: 6px;
   padding: 6px 10px 6px 26px;
   transition: all .2s ease;
}

.sidebar-wrapper .metismenu .financeiro-submenu .submenu-link:hover {
   color: var(--color-theme);
}

.financeiro-submenu li.sub-ativo > .submenu-link {
   color: var(--color-theme) !important;
   font-weight: 500;
   background-color: color-mix(in srgb, var(--color-theme) 12%, #0000);
} */
</style>

